export default __webpack_public_path__ + "assets/community-two-two.90c539f43f5d62359e743b2bd6b47128.png";